import { useUser } from "@clerk/nextjs"

import { hasCovalAdminAccess } from "./coval-admin-access"

export function isLocalDevelopmentRuntime() {
  return process.env.NODE_ENV === "development"
}

/**
 * Deployment-tier check (Vercel's own classification), independent of the
 * Next.js build mode. NODE_ENV is "production" for preview/staging builds
 * too, so use this instead of isLocalDevelopmentRuntime when mirroring the
 * backend's `is_production()` (COVAL_ENVIRONMENT === "prod") semantics.
 */
export function isProductionDeployment() {
  return process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
}

export const useAdminAccess = () => {
  const { user } = useUser()
  return hasCovalAdminAccess(user?.primaryEmailAddress)
}
